export const selectList = state => state.newsReducer.list;
